// AlunoFotoPorTurmaContainer.jsx
import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import TurmaProfile from "../Turma/TurmaProfile";
import TurmaTableSelect from "../Turma/TurmaTableSelect";
import AlunoFotoListV2 from "./AlunoFotoListV2";
import Loading from "../UI/Loading";
import { useAlunoFotos } from "./hooks/useAlunoFotos";

const AlunoFotoPorTurmaContainer = () => {
  const [turma, setTurma] = useState(null);
  const { listaAF, isLoading } = useAlunoFotos(turma);

  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        m: "5px",
        p: "10px",
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <Typography variant="h6">Aluno Foto por Turma</Typography>

      {turma ? (
        isLoading ? (
          <Loading description="Carregando Fotos..." />
        ) : (
          <>
            <TurmaProfile
              turma={turma}
              handleTrocaTurma={() => setTurma(null)}
            />
            <AlunoFotoListV2 listaAF={listaAF} />
          </>
        )
      ) : (
        <TurmaTableSelect onTurmaSelected={setTurma} />
      )}
    </Box>
  );
};

export default AlunoFotoPorTurmaContainer;
